<template>
  <div class="">
    <v-card :loading="isLoadingCar || savingInProgress">
      <v-card-text>
        <v-tabs v-model="carFormTabsId" slider-color="accent">
          <v-tab ripple>
            <v-icon small left>$garage</v-icon>
            {{ $t("common.car") }}
          </v-tab>
          <v-tab ripple>
            <v-icon small left>$cart</v-icon>
            {{ $t("common.customer_orders") }}
          </v-tab>
          <v-tab ripple>
            <v-icon small left>$calculator</v-icon>
            {{ $t("navigation.calculations") }}
          </v-tab>
          <v-tab ripple>
            <v-icon small left>$bids</v-icon>
            {{ $t("navigation.bids") }}
          </v-tab>
          <v-spacer></v-spacer>
          <v-btn
              elevation="0"
              min-width="36"
              min-height="36"
              v-if="car.id && carFormTabsId==0"
              @click="remove"
              color="red lighten-2"
              class="mb-0 ml-3 px-0 white--text"
              :disabled="isLoadingCar || savingInProgress"
              :loading="isLoadingCar|| savingInProgress"
              :title="$t('common.remove')"
          >
            <v-icon small>$trash</v-icon>
          </v-btn>
          <v-btn
              min-width="36"
              min-height="36"
              :title="$t('common.maintenance_parts')"
              @click="
                    $store.dispatch('garage/maintenanceParts', {
                      brand: car.brand,
                      link: car.levam_link,
                      car: car,
                    });
                    maintenancePartsForm = true;
                  "
              :disabled="!car.maintenance_part_available"
              color="secondary"
              elevation="0"
              class="mb-0 ml-3 px-0 white--text"
          >
            <v-icon small >$oils</v-icon>
          </v-btn>
          <v-btn
              min-width="36"
              min-height="36"
              :disabled="!car.levam_link || car.levam_link == -1 || car.levam_link.toString().length < 10"
              @click="toOEMWidget(car)"
              color="secondary"
              elevation="0"
              class="mb-0 ml-3 px-0 white--text"
              :title="$t('common.to_oem_catalog')"
          >
            <v-icon small >$oem</v-icon>
          </v-btn>
          <v-btn
              min-width="36"
              min-height="36"
              :title="$t('common.creating_order')"
              @click="goToSearchWithCustomerCar(car)"
              color="success"
              elevation="0"
              class="mb-0 ml-3 px-0 white--text"
              :disabled="!car || (car && car.id && !car.customer)"
          >
            <v-icon small >$cart</v-icon>
          </v-btn>
          <v-tab-item v-if="!isLoadingCar">
            <v-row>
              <v-col cols="auto">
                <v-img
                  :src="car.image ? car.image : $imgDummyPath"
                  width="150px"
                />
              </v-col>
              <v-col cols="8">
                <p class="py-0">
                  <strong>{{ $t("common.customer") }}: </strong>
                  <span
                      class="dashed"
                      @click="
                  customerId = car.customer.id;
                  customerEditForm = true;
                "
                  >{{ car.customer && car.customer.full_name }}</span
                  >
                  <span v-if="car && car.id && !car.customer">{{ $t("viewOrders.customer_is_deleted") }}</span>
                </p>
                <p>
                  <strong>{{ $t("common.vin_frame") }}: </strong>{{ car.vin }}
                </p>
              </v-col>
            </v-row>

            <v-text-field
              outlined
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
                (v) => !!v || $t('form.validationErrors.must_be_greater', [0]),
              ]"
              :value="car.name"
              v-model="car.name"
              :label="$t('common.title')"
            ></v-text-field>
            <v-text-field
              outlined
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
                (v) => !!v || $t('form.validationErrors.must_be_greater', [0]),
              ]"
              :value="car.car_number"
              v-model="car.car_number"
              :label="$t('common.car_number')"
            ></v-text-field>
            <v-text-field
              outlined
              :rules="[
                v => (v == null || false || v === '') || (v>1950 || $t('form.validationErrors.must_be_greater', [1950]))
              ]"
              :value="car.year"
              v-model="car.year"
              :label="$t('common.year')"
            ></v-text-field>
            <v-row class="px-2">
              <h2 class="pt-3 ml-1">
                {{ $t("common.mileage") }}
                <v-btn
                  color="success"
                  class="ml-1 green-shadow"
                  x-small
                  fab
                  max-width="26"
                  max-height="26"
                  @click="newMileageWindow = !newMileageWindow"
                >
                  <v-icon x-small>$plus</v-icon>
                </v-btn>
              </h2>
            </v-row>
            <v-data-table
              :headers="[
                { text: $t('common.date'), value: 'created_at' },
                { text: $t('common.mileage'), value: 'value' },
              ]"
              :items="car.mileages"
              class="elevation-0 mt-3"
              :footer-props="{
                'items-per-page-text': $t('tables.items_per_page'),
                'items-per-page-options': [
                  10, 50, 100,
                  //-1
                ],
              }"
            >
              <template v-slot:footer.page-text="props">
                {{
                  $t("tables.x_of_y", [
                    `${props.pageStart}-${props.pageStop}`,
                    props.itemsLength,
                  ])
                }}
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ item.created_at | moment("DD.MM.YYYY") }}
                <br/>
                {{ item.created_at | moment("HH:mm") }}
              </template>
              <template v-slot:no-data>
                {{ $t("common.no_data_available") }}
              </template>
              <template v-slot:no-results>
                {{ $t("common.no_data_available") }}
              </template>
            </v-data-table>
            <v-divider class="my-5"></v-divider>
            <v-card-actions class="pa-0">
              <v-spacer></v-spacer>
              <v-btn
                @click="submit()"
                elevation="0"
                class="mr-0"
                color="primary"
              >
                {{ $t("common.save") }}
              </v-btn>
            </v-card-actions>
          </v-tab-item>
          <v-tab-item>
            <v-data-table
                v-if="car && car.orders"
              :headers="tableOrdersHeader"
              :items="car.orders"
              class="elevation-0 mb-3"
              :footer-props="{
                    'items-per-page-text': $t('tables.items_per_page'),
                    'items-per-page-options': [
                      50, 100,
                      //-1
                    ],
                  }"
            >
              <template v-slot:footer.page-text="props">
                {{
                  $t("tables.x_of_y", [
                    `${props.pageStart}-${props.pageStop}`,
                    props.itemsLength,
                  ])
                }}
              </template>
              <template v-slot:item="props">
                <tr>
                  <td class="text-left">
                    <span
                      class="dashed pointer"
                      @click="openOrderWin(props.item.id)"
                      >{{ props.item.human_number }}</span
                    >
                  </td>
                  <td class="text-right text-no-wrap">{{ formatCurrency(props.item.total_sum) }}</td>
                  <td class="text-left text-no-wrap">
                    <v-chip
                      small
                      :color="props.item.status.color"
                      :style="{
                        color: getCorrectTextColor(props.item.status.color),
                      }"
                      class="ma-2"
                      >{{
                        props.item.status_type === "system_order_status"
                          ? $t(
                              "common.orderSystemStatusNames." +
                                props.item.status.name
                            )
                          : props.item.status.name
                      }}
                    </v-chip>
                    <v-chip
                      small
                      :color="props.item.status_payment.color"
                      :style="{
                        color: getCorrectTextColor(
                          props.item.status_payment.color
                        ),
                      }"
                      class="ma-2"
                    >
                      {{
                        $t(
                          "common.paymentStatuses." +
                            props.item.status_payment.name
                        )
                      }}
                    </v-chip>
                  </td>
                  <td class="text-center text-no-wrap">
                    <v-icon
                      small
                      class="pointer mr-2"
                      v-if="
                        props.item &&
                        props.item.items &&
                        props.item.items.find((el) => el.idx === 'spec_diag')
                      "
                      @click="
                        showDiagnosticWindow(
                          props.item.items.find((el) => el.idx === 'spec_diag')
                        )
                      "
                    >
                      fa-tasks
                    </v-icon>
                  </td>
                  <td class="text-xs-left text-no-wrap">
                    {{ props.item.created_at | moment("DD.MM.YYYY") }}
                    <br/>
                    {{ props.item.created_at | moment("HH:mm") }}
                  </td>
                </tr>
              </template>
              <template v-slot:no-data>
                {{ $t("common.no_data_available") }}
              </template>
              <template v-slot:no-results>
                {{ $t("common.no_data_available") }}
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item>
            <v-data-table
              :headers="tableCalculationsHeader"
              :items="car.calculations"
              class="elevation-0 mb-3 tableCalculations"
              @click:row="tableCalculationsRowClick"
              :footer-props="{
                    'items-per-page-text': $t('tables.items_per_page'),
                    'items-per-page-options': [
                      50, 100,
                      //-1
                    ],
                  }"
            >
              <template v-slot:footer.page-text="props">
                {{
                  $t("tables.x_of_y", [
                    `${props.pageStart}-${props.pageStop}`,
                    props.itemsLength,
                  ])
                }}
              </template>
              <template v-slot:item.total_sum="{ item }">
                {{ formatCurrency(item.total_sum) }}
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ item.created_at | moment("DD.MM.YYYY") }}
                <br/>
                {{ item.created_at | moment("HH:mm") }}
              </template>
              <template v-slot:no-data>
                {{ $t("common.no_data_available") }}
              </template>
              <template v-slot:no-results>
                {{ $t("common.no_data_available") }}
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item>
            <v-data-table
                :loading="isLoadingCar"
                :headers="tableBidsHeader"
                :items="car.bids"
                class="elevation-0 mb-3 tableCalculations"
                :footer-props="{
                'items-per-page-text': $t('tables.items_per_page'),
                'items-per-page-options': [
                  50, 100,
                  //-1
                ],
              }"
            >
              <template v-slot:footer.page-text="props">
                {{
                  $t("tables.x_of_y", [
                    `${props.pageStart}-${props.pageStop}`,
                    props.itemsLength,
                  ])
                }}
              </template>
              <template v-slot:item.created_at="props">
                {{ props.item.created_at | moment("DD.MM.YYYY") }}
                <br/>
                {{ props.item.created_at | moment("HH:mm") }}
              </template>
              <template v-slot:item.phone="props">
                <span v-if="props.item.customer">
                  {{ props.item.customer.phone }}
                </span>
                <span v-else>
                  {{ props.item.customer_phone }}
                </span>
              </template>
              <template v-slot:item.desired_date="props">
                {{ props.item.desired_date | moment("DD.MM.YYYY") }}
                <br/>
                {{ props.item.desired_date | moment("HH:mm") }}
              </template>
              <template v-slot:item.comment="props">
                {{ props.item.comment }}
              </template>
              <template v-slot:item.operations="props">
                <div v-for="operation in props.item.operations">
                  {{ getOperationName(operation, lang) }}
                </div>
              </template>
              <template v-slot:item.url="props">
                <v-btn
                    fab
                    small
                    text
                    v-if="props.item.url"
                    :href="props.item.url"
                    :title="props.item.url"
                    target="_blank"
                    :disabled="isLoadingCar"
                ><v-icon small>fa-link</v-icon></v-btn
                >
                <v-chip small v-for="utm in props.item.utm" class="ma-1">
                  {{ utm.key }}: {{ utm.value }}
                </v-chip>
              </template>
              <template v-slot:item.stage="props">
                <bid-stage-select
                    :bid-stages="bidStages"
                    :stage="props.item.stage"
                    :loading="
                    nowProcessingBidWithId === props.item.id ||
                    !bidsStagesIsFetched
                  "
                    @update="
                    (st) => {
                      props.item.stage = st;
                      props.item.bid_stage_id = st.id;
                      updateBid(props.item);
                    }
                  "
                ></bid-stage-select>
              </template>
              <template v-slot:item.actions="props">
                <div class="text-right" style="min-width: 100px">
                  <span class="btn-td-wrap">
                    <v-btn
                        elevation="0"
                        min-width="36"
                        min-height="36"
                        color="primary"
                        class="mb-0 ml-3 px-0 white--text"
                        :title="$t('common.edit')"
                        :disabled="isLoadingCar"
                        @click="
                        activeBid = props.item;
                        bidWindow = true;
                        activeBid.customer = car.customer
                      "
                    >
                      <v-icon small>$pencil</v-icon>
                    </v-btn>
                    <v-btn
                        elevation="0"
                        min-width="36"
                        min-height="36"
                        class="mb-0 ml-3 px-0 white--text"
                        :color="!props.item.order ? 'success' : 'blue'"
                        :title="
                        !props.item.order
                          ? $t('common.creating_order')
                          : $t('common.go_to_order')
                      "
                        :disabled="isLoadingCar"
                        @click="handleClickOrderForBid(props.item)"
                    >
                      <v-icon small>$cart</v-icon>
                    </v-btn>
                  </span>
                </div>
              </template>
              <template v-slot:no-data>
                {{ $t("common.no_data_available") }}
              </template>
              <template v-slot:no-results>
                {{ $t("common.no_data_available") }}
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
    </v-card>

    <v-dialog v-model="newMileageWindow" scrollable max-width="400px">
      <v-card class="">
        <v-card-text class="pa-5">
          <v-text-field
            outlined
            :rules="[
              (v) => !!v || $t('form.validationErrors.field_is_required'),
              (v) => !!v || $t('form.validationErrors.must_be_greater', [0]),
            ]"
            :value="carTmpMileage"
            v-model="carTmpMileage"
            :label="$t('common.mileage')"
          ></v-text-field>
        </v-card-text>
        <v-divider class="mx-5"></v-divider>
        <v-card-actions class="pt-0 pb-4">
          <v-spacer></v-spacer>
          <v-btn
            @click="
              newMileageWindow = false;
              carTmpMileage = null;
            "
            class="mr-2 mt-4 white--text"
            elevation="0"
            color="red"
          >
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            @click="
              newMileageWindow = false;
              newMileage();
            "
            elevation="0"
            class="mr-2 mt-4"
            color="primary"
          >
            {{ $t("common.add") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="customerEditForm" scrollable max-width="890">
      <customerForm
        v-if="customerEditForm"
        @removed="customerEditForm=false"
        :is-visible="customerEditForm"
        @store="
          (data) => {
            this.customerEditForm = false;
            this.car.customer = data;
          }
        "
        :customer-id="customerId"
      ></customerForm>
    </v-dialog>
    <v-dialog v-model="maintenancePartsForm" scrollable max-width="90%">
      <maintenanceParts></maintenanceParts>
    </v-dialog>
    <diagnostic-window
      :show="orderItemDiagnosticWindow.isVisible"
      :item="orderItemDiagnosticWindow.item"
      @hide="orderItemDiagnosticWindow.isVisible = false"
    ></diagnostic-window>

    <bid-window
        :show="bidWindow"
        :bid-id="activeBid && activeBid.id"
        :customer="activeBid && activeBid.customer"
        @hide="
        bidWindow = false;
        activeBid = null;
      "
        @update="
        (bid) => {
          activeBid = null;
        }
      "
    />
    <order-window
        :is-visible="orderWindow.isVisible"
        :order-id="orderWindow.orderId"
        @hide="orderWindow.orderId=null; orderWindow.isVisible=false;onLoad()"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import MaintenanceParts from "@/components/garage/MaintenanceParts";
import DiagnosticWindow from "../order/DiagnosticWindow";
import BidStageSelect from "@/components/bid/BidStageSelect";
import BidWindow from "@/components/bid/BidWindow";
import CommonMixin from "@/mixins/common";
import BidsMixin from "@/mixins/bids";
//import OrderWindow from "@/components/order/OrderWindow.vue";

export default {
  name: "CarForm",
  components: {
    OrderWindow: () => import("@/components/order/OrderWindow.vue"),
    BidWindow,
    BidStageSelect,
    DiagnosticWindow,
    MaintenanceParts,
    customerForm: () => import("@/components/customer/CustomerForm.vue"),
  },
  mixins: [CommonMixin, BidsMixin],
  props: {
    carId: {
      type: Number,
      default: null,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch:{
    async show(to){
      if(this.carId) {
        this.car = await this.$store.dispatch('garage/getCar', {id: this.carId});
      }
    }
  },
  data: () => ({
    id: null,
    carTmpMileage: null,
    maintenancePartsForm: false,
    newMileageWindow: false,
    customerEditForm: false,
    customerId: false,
    orderItemDiagnosticWindow: {
      isVisible: false,
      item: null,
    },
    bidWindow: false,
    activeBid: null,
    car: {
      engine: null,
      brand: null,
      catalog_code: null,
      family: null,
      model: null,
      link: null,
      name: null,
      mileage: null,
      customer_id: null,
      vin: null,
      car_number: null,
      image: null,
    },
    orderWindow: {
      orderId: null,
      isVisible: false
    }
  }),
  validations() {
    return {
      customer: {
        email: { required, email },
      },
    };
  },
  mounted() {
    this.onLoad();
  },
  computed: {
    tableBidsHeader() {
      return [
        {
          text: this.$t("common.created_at"),
          value: "created_at",
          sortable: true,
          class: "text-no-wrap",
        },

        {
          text: this.$t("viewBids.desired_date"),
          value: "desired_date",
          sortable: true,
          class: "text-no-wrap",
        },

        {
          text: this.$t("common.repairtimes"),
          value: "operations",
          sortable: false,
        },
        {
          text: this.$t("viewBids.url"),
          value: "url",
          sortable: true,
          class: " text-no-wrap",
        },
        {
          text: this.$t("viewBids.bid_status"),
          sortable: false,
          class: "text-no-wrap",
          value: "stage",
        },
        {
          text: "",
          sortable: false,
          class: "text-no-wrap flex-nowrap justify-space-between",
          is_action_column: true,
          value: "actions",
        },
      ];
    },
    tableCalculationsHeader() {
      return [
        {
          text: this.$t("viewOrders.tableHeader.human_number"),
          value: "id",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.title"),
          value: "name",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.total_sum"),
          value: "total_sum",
          sortable: true,
          align: "left",
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewOrders.tableHeader.created_at"),
          value: "created_at",
          sortable: true,
          class: "text-no-wrap",
        },
      ];
    },
    tableOrdersHeader() {
      return [
        {
          text: this.$t("viewOrders.tableHeader.human_number"),
          value: "human_number",
          sortable: true,
        },
        {
          text: this.$t("viewOrders.tableHeader.total_sum"),
          value: "total_sum",
          sortable: true,
          align: "right",
        },
        { text: this.$t("common.status"), value: "status", sortable: true },
        { text: this.$t("viewOrders.tableHeader.diagnostic"), sortable: false },
        {
          text: this.$t("viewOrders.tableHeader.created_at"),
          value: "created_at",
          sortable: true,
        },
      ];
    },
    ...mapFields("bids", ["nowProcessingBidWithId"]),
    ...mapFields("bid_stages", ["bidStages"]),
    ...mapFields("bid_stages", { bidsStagesIsFetched: "fetched" }),
    ...mapFields("garage", [
      "carFormTabsId",
      "isLoadingCar",
      "savingInProgress",
    ]),
  },
  methods: {
    updateBid(bid) {
      this.$store.dispatch("bids/update", bid).then((res) => {});
    },
    openOrderWin(id){
      this.orderWindow.isVisible = true;
      this.orderWindow.orderId = id;
    },
    async handleClickOrderForBid(bid) {
      if (bid.order && bid.order.id) {
        this.openOrderWin(bid.order.id)
        return;
      }

      if (parseInt(bid.customer_car_id) > 0) {
        this.goToSearchWithCustomerCar(this.car, null, bid.id);
        return;
      }
      if (parseInt(bid.customer_id) > 0) {
        this.goToSearchWithCustomer(this.car.customer, bid.id);
        return;
      }
    },
    async onLoad() {
      this.$store.dispatch("bid_stages/get");
      if(this.carId) {
        this.car = await this.$store.dispatch('garage/getCar', {id: this.carId});
      }
    },
    remove(){
      this.$store.dispatch('garage/carRemove', { id: this.car.id }).then((result)=>{
        if(result) {
          this.$emit("removed");
        }
      })
    },
    tableCalculationsRowClick(item) {
      this.$router.push({ name: "calculations", params: { id: item.id } });
    },
    showDiagnosticWindow(item) {
      this.orderItemDiagnosticWindow.item = item;
      this.orderItemDiagnosticWindow.isVisible = true;
    },
    newMileage() {
      this.car.mileages.push({
        created_at: this.$t("common.now"),
        value: this.carTmpMileage,
      });
      this.carTmpMileage = null;
    },
    submit() {
      this.$store
        .dispatch("garage/updateCar", { id: this.car.id })
        .then((car) => {
          this.$emit("store", car);
        });
    },
  },
};
</script>

<style>
.tableCalculations tr {
  cursor: pointer;
}
</style>
